





















import Vue from 'vue'
import AdvancedPaginationTable from "@/components/tables/AdvancedPaginationTable.vue";

export default Vue.extend({
  components: {AdvancedPaginationTable},
  data() {
    return {
      search: '',
    }
  },
  computed: {
    headers: function () {
      return [
        {
          text: 'Fullname',
          value: 'fullname',
          width: '20%',
        },
        {
          text: 'Email',
          value: 'email',
          width: '20%',
        },
        {
          text: 'Grantors',
          value: 'grantors',
          width: '50%',
          formatter: (grantor) => {
            return grantor.fullname
          },
        },
      ]
    }
  },
})
